import { Component, OnInit } from '@angular/core';
import {UntypedFormGroup,Validators,UntypedFormBuilder}from '@angular/forms';
@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
    host: { 'class': 'login' },
    standalone: false
})
export class SignupComponent implements OnInit {

  form:UntypedFormGroup;
  constructor( private fb:UntypedFormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({
      fullName:['',Validators.required],
      email:['',Validators.required],
      password:['', Validators.required],
      confirmPassword:['',Validators.required]
    });
  }

  login(){
    console.log('login')
  }

}
